import * as React from 'react';

export function FacilitiesUpsell(
  props: React.HTMLAttributes<SVGSVGElement> & { label: string },
) {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label={props.label}
      style={{ marginLeft: '-2px' }}
    >
      <path
        d="M12.6712 24.6116C12.4955 24.8574 12.2143 25 11.9122 25C11.3295 25 10.8886 24.4732 10.9911 23.8996L12.1833 17.2316C12.2929 16.6186 11.8216 16.0556 11.1989 16.0556H6.79642C5.38914 16.0556 6.26869 15.0972 6.30068 15.0589C8.3168 12.2117 11.3257 7.99759 15.3275 2.39276C15.5031 2.14682 15.7873 2 16.0895 2C16.672 2 17.1129 2.52671 17.0104 3.10018L15.8182 9.76844C15.7086 10.3814 16.1799 10.9444 16.8026 10.9444H21.2211C21.8607 10.9444 22.2125 11.1872 21.8607 11.7878C16.6265 19.0829 13.5664 23.3599 12.6712 24.6116Z"
        fill="url(#paint0_linear_844_23013)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_844_23013"
          x1="7.54484"
          y1="2"
          x2="7.54484"
          y2="29.8798"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.35" />
          <stop offset="1" stopColor="white" stopOpacity="0.8" />
        </linearGradient>
      </defs>
    </svg>
  );
}
